import { PropsWithChildren, ChangeEvent } from "react";

import { removeSpaces } from "../helper.js";
import { SelectFieldOption } from "../types/types.js";
import { FormGroup, Select, FormItem, ControlLabel, HelpBlock } from "ui-components";

type Props = {
  className?: string;
  help?: string;
  label?: string;
  placeholder?: string;
  value: string | number;
  handleChange?: (
    e?:ChangeEvent<HTMLSelectElement>
  ) => void;
  error?: string;
  req?: boolean;
  options?: SelectFieldOption[];
  defaultedOption: boolean;
};

const SelectOption = ({
  className,
  label,
  error,
  placeholder,
  handleChange,
  help,
  req,
  value,
  options,
  defaultedOption,
}: PropsWithChildren<Props>) => (
  <FormGroup className={className} validationState={req && error}>
    {label && (
      <ControlLabel forId={removeSpaces(label)}>
        {label} {req && "*"}
      </ControlLabel>
    )}

    <FormItem className="form-control-select">
      <Select
        placeholder={placeholder}
        options={options}
        defaultedOption={defaultedOption}
        onChange={handleChange}
        value={value.toString()}
      />

      {req && help && <HelpBlock>{help}</HelpBlock>}
    </FormItem>
  </FormGroup>
);

export default SelectOption;
